// Lookup_GoalStatus
export enum GoalStatus {
    DRAFT = 1,
    PRE_APPROVAL,
    ACTIVE,
    PENDING_CLOSE,
    CLOSED,
    DELETED,
    UPDATING = 8,
}
